import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http'
import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http'
import type {
    IPatentLinkApi,
    PatentLinkRequestType,
    PatentLinkResponseType,
} from '../patent-link-api'

@injectable()
export class PatentLinkApiImpl extends PsHttpService implements IPatentLinkApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`,
        }
    }

    getPatentLink(params: PatentLinkRequestType) {
        return this.post<PatSnapCommonResponseData<PatentLinkResponseType>>({
            url: '/patent/link',
            data: params,
        }).then(res => {
            return (res || {}) as unknown as PatentLinkResponseType
        })
    }
}
